export const getEnumKeyByValue = <T = any>(enumObject: T, value: T[keyof T]): undefined | keyof T => {
	for (const key in enumObject) {
		if (enumObject[key] === value) return key;
	}
};